<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="myContainer">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">
            <img src="https://mektep.edu.kz/assets/img/logo_edus_mektep.png" height="25" alt="">
          </a>
          <form class="form-inline my-2 my-lg-0">
            <div class="demo">
              <div class="menu-icon" @click="$emit('click')">
                <input class="menu-icon__cheeckbox" type="checkbox" />
                <div>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
            <div class="ml-3 btn btn-outline-success my-2 my-sm-0" @click="logout">Выход</div>
          </form>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    data () {
      return {}
    },
    methods: {
      logout() {
        this.$store.dispatch('logout');
      }
    }
  }
</script>


<style>

.demo {
  display: flex;
  align-items: center;
  justify-content: center;
}
.demo .menu-icon {
  transform: scale(1.5);
}

:root {
  --bar-bg: #212529;
}

.menu-icon {
  position: relative;
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.menu-icon .menu-icon__cheeckbox {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  z-index: 2;
  -webkit-touch-callout: none;
  position: absolute;
  opacity: 0;
}
.menu-icon div {
  margin: auto;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 22px;
  height: 12px;
}
.menu-icon span {
  position: absolute;
  display: block;
  width: 100%;
  height: 2px;
  background-color: var(--bar-bg, #000);
  opacity: 70%;
  border-radius: 1px;
  transition: all 0.2s cubic-bezier(0.1, 0.82, 0.76, 0.965);
}
.menu-icon span:first-of-type {
  top: 0;
}
.menu-icon span:last-of-type {
  bottom: 0;
}


@media (min-width: 1024px) {
  .menu-icon:hover span:first-of-type {
    width: 26px;
  }
  .menu-icon:hover span:last-of-type {
    width: 12px;
  }
}

</style>